const STORAGE_KEY = 'nacanaca-hidden-points-v1';
const COMMUNITY_STORAGE_KEY = 'nacanaca-community-v1';

const loadHiddenPoints = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

export const getPlayerHiddenPoints = (playerName) => {
  const player = loadHiddenPoints()[playerName || 'Invitado'];
  return Number.isFinite(player?.total) ? player.total : 0;
};

export const getHiddenPointsByPlayer = () => Object.fromEntries(
  Object.entries(loadHiddenPoints()).map(([playerName, player]) => [
    playerName,
    Number.isFinite(player?.total) ? player.total : 0,
  ]),
);

export const getPlayerGlobalPoints = (playerName) => {
  const safePlayerName = playerName || 'Invitado';
  let gamePoints = 0;
  try {
    const community = JSON.parse(localStorage.getItem(COMMUNITY_STORAGE_KEY)) || {};
    gamePoints = (Array.isArray(community.plays) ? community.plays : [])
      .filter((play) => play.user === safePlayerName)
      .reduce((total, play) => total + (Number(play.score) || 0), 0);
  } catch {
    gamePoints = 0;
  }
  return gamePoints + getPlayerHiddenPoints(safePlayerName);
};

export const HIDDEN_POINTS_STORAGE_KEY = STORAGE_KEY;
export const PLAYER_GAMES_STORAGE_KEY = COMMUNITY_STORAGE_KEY;

// Mantener en sincronía con HIDDEN_POINT_MAPS en public/toluca_mapa_de_supervivencia.html
// (6 mapas x 4 puntos por mapa).
export const HIDDEN_POINT_MAP_IDS = ['general', 'centro', 'norte', 'tollocan', 'ceu', 'parque'];
export const HIDDEN_POINTS_PER_MAP = 4;
export const HIDDEN_POINTS_TOTAL = HIDDEN_POINT_MAP_IDS.length * HIDDEN_POINTS_PER_MAP;

const getActiveCooldownEnds = (playerName) => {
  const player = loadHiddenPoints()[playerName || 'Invitado'];
  const cooldowns = player?.cooldowns || {};
  const now = Date.now();
  return Object.values(cooldowns)
    .map((availableAt) => Number(availableAt))
    .filter((availableAt) => Number.isFinite(availableAt) && availableAt > now);
};

// Puntos de la ronda actual encontrados (los que siguen ocultos por cooldown de 1 h).
export const getPlayerHiddenPointsFound = (playerName) => getActiveCooldownEnds(playerName).length;

// Ms hasta que se regenere el próximo punto (0 si no hay ninguno pendiente).
export const getPlayerHiddenPointsResetMs = (playerName) => {
  const ends = getActiveCooldownEnds(playerName);
  if (!ends.length) return 0;
  return Math.max(0, Math.min(...ends) - Date.now());
};
